import React, { useContext } from "react";
import "../styles/Results.css";
import { TimerContext } from "../context/TimerContext";
import { GameContext } from "../context/GameContext";

export const Results = () => {
  const { price, minimumWin, maximumWin, lines, limitLabel, limit } =
    useContext(GameContext);
  const { selectedDay } = useContext(TimerContext);

  const formatAmount = (amount) => {
    return parseFloat(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div className="results-card">
      <div className="results-group">
        <span className="results-label">Price:</span>
        <span className="results-value">GH₵ {formatAmount(price)}</span>
      </div>
      <div className="results-group">
        <span className="results-label">Minimum Win:</span>
        <span className="results-value">GH₵ {formatAmount(minimumWin)}</span>
      </div>
      {(!(
        (limit.includes(1) && limit.includes(2)) ||
        (limit.includes(1) && limit.includes(3)) ||
        (limit.includes(5) && limit.includes(13)) ||
        (limit.includes(6) && limit.includes(12)) ||
        (limit.includes(1) && !limit.includes(24))
      )) && (
        <div className="results-group">
          <span className="results-label">Maximum Win:</span>
          <span className="results-value">GH₵ {formatAmount(maximumWin)}</span>
        </div>
      )}
      <div className="results-group">
        <span className="results-label">LINES:</span>
        <span className="results-value">{lines}</span>
      </div>
      <div className="results-group">
        <span className="results-label">Game Type:</span>
        <span className="results-value">{limitLabel}</span>
      </div>
      <div className="results-group">
        <span className="results-label">Game:</span>
        <span className="results-value">
          {selectedDay.d || selectedDay.sortedGames?.[0]?.d || ""}
        </span>
      </div>
      <div className="results-group">
        <span className="results-label">Closing Time:</span>
        <span className="results-value">
          {selectedDay.closingTime || selectedDay.sortedGames?.[0]?.closingTime || ""}
        </span>
      </div>
      <div className="results-group">
        <span className="results-label">Draw Date:</span>
        <span className="results-value">
          {selectedDay.nextGameDate || selectedDay.sortedGames?.[0]?.nextGameDate || ""}
        </span>
      </div>
    </div>
  );
};

export default Results;
